<template>
    <div style="background: #F0F2F5 !important;padding: 16px !important;" class="contractindex" :style="conheight">
        <!-- <h3 class="flow_table_title">借阅合同列表</h3> -->
        <div style="background: #ffffff !important;" :style="conheight">
            <el-main class="request_content">
                <div class='search'>
                    合同号：  <el-input style="width:25%" placeholder="请输入内容" v-model="hth" ></el-input>
                    品牌名称：<el-input style="width:25%" placeholder="请输入内容" v-model="pp"></el-input>
                    <!-- 合同编号：<el-input style="width:25%" placeholder="请输入内容" v-model="htbh"></el-input> -->
                    <el-button type="primary" @click="initData()" icon="el-icon-search">查询</el-button>
                </div>
                <el-table :data="tableData" stripe style="width: 100%">
                    <el-table-column align="center" label="序号" width="50">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="F_PP" align="center" label="品牌" min-width="15%"></el-table-column>
                    <el-table-column prop="F_HTH" align="center" label="合同号" min-width="10%"></el-table-column>
                    <el-table-column prop="F_MD" align="center" label="门店名称" min-width="15%"></el-table-column>
                    <el-table-column prop="F_KSRQ" align="center" label="开始日期" min-width="10%"></el-table-column>
                    <el-table-column prop="F_JSRQ" align="center" label="结束日期" min-width="10%"></el-table-column>
                    <el-table-column prop="DEPT_NAME" align="center" label="楼层" min-width="10%"></el-table-column>
                    <el-table-column prop="F_HTWD" label="合同附件" min-width="30%">
                        <template slot-scope="scope">        
                            <div v-for="(item,index) in JSON.parse(scope.row.F_HTWD)" :key="index">
                                <a @click="preview(item,scope.row.F_HTH)">{{item.name}}</a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [],
        iframeSrcContract:"",
        hth:"",
        pp:"",
        conheight:{ height:window.innerHeight -64 + "px" },
      }
    },
    mounted:function(){//加载事件
        window.jQuery("#hycontent").find(".el-main").css({"height":window.innerHeight+"px"});
        window.jQuery(".el-main").css({"overflow":"hidden"});
      //this.initData();//加载时触发数据填充
    },
    methods:{
        //下面是函数
        initData(){
            let User = JSON.parse(window.sessionStorage.currentUser);
            let htbh = this.pp.toUpperCase();
            this.$http.post(`${window.context.portal}/bpm/haiyaScript/getContract?hth=${this.hth}&pp=`+htbh+`&gh=`+User.account).then((resp) => {
                let data = resp.data;
                this.tableData=[];
                if(data==null || data=='null'){
                    this.$message({
                        message: '未能获取到相关合同信息，请确认合同是否归档！',
                        type: 'success'
                    })
                    return;
                }
                for(let i=0;i<data.length;i++){
                    this.tableData.push({
                        F_PP:"",
                        F_HTH:"",
                        F_MD:"",
                        F_KSRQ:"",
                        F_JSRQ:"",
                        F_HTBH:"",
                        F_HTWD:""
                    });
                    this.tableData[i].F_PP = data[i].F_PP;   
                    this.tableData[i].F_HTH = data[i].F_HTH;
                    this.tableData[i].F_MD = data[i].F_MD;
                    this.tableData[i].F_KSRQ = this.formatDate(data[i].F_KSRQ);
                    this.tableData[i].F_JSRQ = this.formatDate(data[i].F_JSRQ);
                    this.tableData[i].F_HTBH = data[i].F_HTBH;
                    this.tableData[i].DEPT_NAME = data[i].DEPT_NAME;
                    if(data[i].F_HTWD.length>0){
                        this.tableData[i].F_HTWD = JSON.parse(JSON.stringify(data[i].F_HTWD));
                    }else{
                        this.tableData[i].F_HTWD = "";
                    }
                }
            });
        },
        formatDate(stamp) {//时间戳转换为日期格式
            let date = new Date(stamp);
            let YY = date.getFullYear() + '-';
            let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            //return YY + MM + DD +" "+hh + mm + ss;//年月日时分秒
            return YY + MM + DD;//年月日
        },
        preview(item,hth){//附件预览
            //记录用户查阅附件记录
            let User = JSON.parse(window.sessionStorage.currentUser);
            let param ="fullname="+User.username+"&account="+User.account+"&hth="+hth;
            this.$http.post(`${window.context.portal}/bpm/haiyaScript/InsertHtcyjl?`+param).then((resp) => {
                let data = resp.data;
                debugger;
            });

            let row = item;
            
            let fileid = row.id;
            if(fileid==undefined || fileid=='undefined'){
                fileid = row.response.fileId;
            }
            let idocType = ["doc","docx","xls","xlsx","ppt","pptx","pdf","txt","jpg","jpeg","gif","png","bmp","tif","mp3","m4a","mid","wma","mp4","zip","rar","tar","7z"];      
            let type;
            this.$http.post(`${window.context.portal}/bpm/aliasScript/v1/execute/FileType?id=${fileid}`).then((resp) => {
                if(!resp.data.value){
                    this.$message({
                        message: '当前文件已损坏无法继续查看，请联系相关人员提供原件！',
                        type: 'success'
                    })
                    return;
                }
                type = resp.data.value[0].FILETYPE;
                setTimeout(() => {
                    if (idocType.includes(type)) {
                        let token = "testtoken";
                        let idocvUrl = "http://10.10.10.74:8168";
                        let url = encodeURIComponent(window.context.portal+"/system/file/v1/downloadFile?fileId=" +fileid);

                        //***** 外网 *****/
                        if(window.location.origin.indexOf("http://61.144.170.91/9080")>-1){//副线环境
                            idocvUrl = "https://idocv.haiya.com.cn";
                        }

                        if(window.location.origin.indexOf("https://sh.haiya.com.cn")>-1){//副线环境
                            idocvUrl = "https://idocv.haiya.com.cn";
                        }

                        this.$http.get(`${idocvUrl}/doc/upload?token=${token}&url=${url}`).then((resp) => {
                            if(!resp.data.uuid){
                                this.$message({
                                    message: '当前文件已损坏无法继续查看，请联系相关人员提供原件！',
                                    type: 'success'
                                })
                                return;
                            }
                            this.iframeSrcContract = idocvUrl+"/view/" + resp.data.uuid+"?watermark="+User.account;
                            let iTop = (window.screen.availHeight - 30 - 700) / 2;
                            let iLeft = (window.screen.availWidth - 10 - 700) / 2;
                            window.open(this.iframeSrcContract,'_blank','width=900,height=800,menubar=no,toolbar=no, status=no,top='+iTop+',left='+iLeft+',scrollbars=yes');
                        });
                    }else{
                        this.$http.get(`${window.context.portal}/system/file/v1/downloadFile?fileId=${fileid}`).then((resp) => {
                            this.$message({
                            message: '此附件类型暂不支持在线查看，开始为您下载到本地中查看！',
                            type: 'success'
                            })
                        });
                    }
                }, 500);
            });
        },
    }
  }
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");
/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
  a{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
    /deep/ .search{
        padding-bottom: 20px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #292B44;
    }
    /deep/.el-table th{
        height: 48px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #292B44;
        background: #F0F2F5;
        text-align: left;
    }
    /deep/.flow_table_title{
        background-color: #FFFFFF;
        font-size: 14px;
        // border-bottom: 1px solid #ccc;
        margin: 17px 17px 2px 17px;
        padding: 12px 20px;
    }

    /deep/.el-table tr:nth-child(even){
        background: rgb(240, 241, 241);
    }
    /deep/.el-table th,
    /deep/.el-table td {
    //border-right:1px dashed #000000;
    border-bottom: 1px solid #F0F2F5;
    border-right: 0px dashed rgb(218, 218, 218);
    }

    /deep/.el-table tr:hover > td{
        background-color:#EDF6FB !important;
    }
    .form-content-wrap {
    padding: 0px 20px 20px 20px;
    // 隐藏滚动条
    &::-webkit-scrollbar {
        width: 0;
        background-color: transparent;
    }
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
    }
</style>